import React, { useState } from 'react'
import { useCookies } from 'react-cookie'
import { Modal } from '../../components/Modal/Modal'
import { LIVE_MEETINGS_COOKIE_MAX_AGE, LIVE_MEETINGS_HIDE_VIDEO_COOKIE, useLiveMeetingsFlags } from './hooks'
import { OnboardingTrackEvent, useTracking } from '../../apps/professional-app/fa/common/tracking'
import { ArcadeEmbed } from '../GettingStarted/ArcadeEmbed'

export const LiveMeetingsVideo: React.FC = () => {
  const [, setCookie] = useCookies()

  const { trackingClient } = useTracking()

  const { shouldShowLiveMeetingsVideo } = useLiveMeetingsFlags()

  const [show, setShow] = useState(shouldShowLiveMeetingsVideo)

  if (!show) {
    return null
  }

  const handleViewLiveMeetingsVideo = () => {
    trackingClient.track({ eventName: OnboardingTrackEvent.LIVE_MEETINGS_VIDEO_VIEWED, eventDetails: { source: 'liveMeetings' } })
  }

  const handleHide = () => {
    setShow(false)
    setCookie(LIVE_MEETINGS_HIDE_VIDEO_COOKIE, true, { path: '/', maxAge: LIVE_MEETINGS_COOKIE_MAX_AGE })
  }

  const body = (
    <div className='d-flex align-items-center justify-content-center mt-3 mb-5'>
      <ArcadeEmbed
        url='https://demo.arcade.software/EufjtoB55TcnTLiDKGd1?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true'
        title='Live meetings in Zocks'
        onArcadeStarted={handleViewLiveMeetingsVideo}
      />
    </div>
  )

  return <Modal show={show} size='lg' header={<h4>Live Meetings</h4>} body={body} onHide={handleHide} />
}
